import { useEffect, useState } from 'react';
export const useScrollPosition = (ref) => {
    if (process.env.NODE_ENV === 'development') {
        if (typeof ref !== 'object' || typeof ref.current === 'undefined') {
            console.error('useScrollPosition expects a single ref argument');
        }
    }
    const [state, setState] = useState({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    });
    useEffect(() => {
        const el = ref.current;
        const handleScroll = () => {
            if (el) {
                const horizontalScrollbar = el.scrollWidth > el.clientWidth;
                const verticalScrollbar = el.scrollHeight > el.clientHeight;
                const bottom = el.scrollHeight - el.scrollTop - el.clientHeight;
                const right = el.scrollWidth - el.scrollLeft - el.clientWidth;
                setState({
                    top: verticalScrollbar ? Math.round(el.scrollTop) : false,
                    right: horizontalScrollbar ? Math.round(right) : false,
                    bottom: verticalScrollbar ? Math.round(bottom) : false,
                    left: horizontalScrollbar
                        ? Math.round(el.scrollLeft)
                        : false,
                });
            }
        };
        /** Handle scroll once rendered */
        requestAnimationFrame(handleScroll);
        el && on(el, 'scroll', handleScroll, { capture: false, passive: true });
        return () => el && off(el, 'scroll', handleScroll);
    }, [ref]);
    return state;
};
/* https://github.com/streamich/react-use/blob/master/src/misc/util.ts */
function on(obj, ...args) {
    var _a;
    (_a = obj === null || obj === void 0 ? void 0 : obj.addEventListener) === null || _a === void 0 ? void 0 : _a.call(obj, ...args);
}
function off(obj, ...args) {
    var _a;
    (_a = obj === null || obj === void 0 ? void 0 : obj.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(obj, ...args);
}
//# sourceMappingURL=useScrollPosition.js.map